import { RectAreaLight } from 'three';

function createRectAreaLight() {
  // 创建一个强度为 10 的纯白光
  const light = new RectAreaLight('yellow', 10, 100);

  // 灯光从(50, 50, 50)照向(0,0,0)
  light.position.set( 50, 50, 50 );

  return light;
}

export { createRectAreaLight };